import React, { Fragment, useContext } from 'react';
import { GoogleMapsPlaceDetails } from '../../container/shop/GoogleMapsPlaceDetails';
import { Divider, Typography } from '@material-ui/core';
import { convert_places_opening_times } from '../../tools/convert_places_opening_times';
import { useRouter } from 'next/router';
import { Tr } from '@lsoft/translate';
import { trOpeningHours } from './OpeningTimes.tr';
import { Alert } from '@material-ui/lab';
import Grid from '@material-ui/core/Grid';


export const NewOpeningTimes = () => {
	const tr_following_opening_hours_apply = {
		DE: 'Ab dem <u>01.03.2023</u> gelten folgende Öffnungszeiten: <u>Dienstag bis Samstag, 10 bis 18 Uhr</u>. Sonntags und montags geschlossen.',
		EN: 'From <u>01.03.2023</u> the following opening hours apply: <u>Tuesday to Saturday, 10 am to 6 pm</u>. Closed on Sundays and Mondays.',
		FR: 'À partir du <u>01.03.2023</u>, les heures d\'ouverture suivantes seront appliquées : <u>Du mardi au samedi, de 10 h à 18 h</u> . Fermé le dimanche et le lundi .'
	};
	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<Divider />
			</Grid>
			<Grid item xs={12}>
				<Alert severity={'info'}>
					<Tr tr={tr_following_opening_hours_apply} html />
				</Alert>
			</Grid>
		</Grid>

	);
};

export const StoreOpeningTimes = () => {
	const { locale } = useRouter();
	const { opening_hours } = useContext(GoogleMapsPlaceDetails.Context);
	const { periods } = opening_hours;

	const times = convert_places_opening_times(periods, locale).map(
		({ day_string, time_string }) => {
			return (
				<Fragment key={day_string}>
					<Typography variant={'body2'}>
						{day_string}: {time_string}
					</Typography>
				</Fragment>
			);
		}
	);
	return (
		<Fragment>
			<Typography variant={'subtitle2'} gutterBottom>
				<Tr tr={trOpeningHours} />
			</Typography>
			{times}
		</Fragment>
	);
};
